import React, { useState, useEffect, useCallback } from "react";
import { Header } from "../Header-Assesment/Header";
import { Card } from "./Card";
import "./Questions-Card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { TabBar } from "./Tab-bar";

const STORAGE_KEY = 'completedAssessmentTabs'; 


const tabFlow = ["physical", "emotional", "acceptance", "relationships", "loving kindness", "intellectual"];

const capitalize = (s) => {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const QuestionCard = ({
    headerTitle = "",
    headerSubtitle = "",
    breadcrumbs = [],
    domain: initialDomain,
}) => {
    const [activeTab, setActiveTab] = useState(initialDomain || "physical");
    const [domainProgress, setDomainProgress] = useState({});

    
    const completedTabs = React.useMemo(() => {
        const currentIndex = tabFlow.indexOf(activeTab.toLowerCase());
        console.log(currentIndex)
        console.log(activeTab)
        if (currentIndex > 0) {
            return tabFlow.slice(0, currentIndex).map(capitalize);
        }
        return [];
    }, [activeTab]);

    const handleTabChange = (tab) => {
        setActiveTab(tab.toLowerCase());
    };

   
    const handleSectionComplete = useCallback((completedTab) => {
       
        const currentTabIndex = tabFlow.indexOf(completedTab.toLowerCase());
        if (currentTabIndex < tabFlow.length - 1) {
            setActiveTab(tabFlow[currentTabIndex + 1]);
        } else {
            console.log("All sections completed.");
        }
    }, []);

    const handleDomainProgressUpdate = (domain, progress) => {
        setDomainProgress((prev) => ({
            ...prev,
            [domain]: progress,
        }));
    };

    return (
        <div className="Questioncard">
            <div className="header-assessment">
                <Header title={headerTitle} subtitle={headerSubtitle} />
            </div>
            <div className="toppart">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, i) => (
                        <React.Fragment key={i}>
                            {crumb.icon && (
                                <FontAwesomeIcon icon={crumb.icon} style={{ color: "#c1c0bd" }} />
                            )}
                            <p className={crumb.active ? "element-text3" : "element-text"}>
                                {crumb.text}
                            </p>
                            {i !== breadcrumbs.length - 1 && <p className="overline">/</p>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <div className="assessment-que">
                <TabBar
                    activeTab={activeTab}
                    setActiveTab={handleTabChange}
                    completedTabs={completedTabs}
                    domainProgress={domainProgress}
                />
                <Card
                    domain={activeTab.toLowerCase()}
                    completedTabs={completedTabs} 
                    activeTab={activeTab}
                    onComplete={handleSectionComplete} 
                    onDomainProgressUpdate={handleDomainProgressUpdate}
                />
            </div>
        </div>
    );
};